import { type WrappedInsight } from "@clipboard-health/contract-backend-main";
import { Box } from "@mui/material";

import { getInsightBackground } from "./Insight/getInsightBackground";
import { KnownInsightContent } from "./Insight/KnownInsightContent";

interface ShareCaptureContainerProps {
  insights: WrappedInsight[];
}

/**
 * Renders all insights off-screen specifically for screenshot capture.
 * These elements are not wrapped in Fade or any animation component,
 * so they're always at full opacity and ready for capture.
 *
 * Each insight is rendered in its own container at a different horizontal offset
 * to avoid overlapping.
 */
export function ShareCaptureContainer(props: ShareCaptureContainerProps) {
  const { insights } = props;

  return (
    <>
      {insights.map((insight, index) => (
        <Box
          key={insight.id}
          id={`capture-${insight.attributes.insightType}`}
          sx={(theme) => ({
            position: "fixed",
            // Each insight is positioned further off-screen to avoid overlap
            left: `${-9999 - index * 1000}px`,
            top: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "stretch",
            background: getInsightBackground(insight.attributes.insightType),
            paddingTop: theme.spacing(3),
            pointerEvents: "none",
          })}
        >
          <KnownInsightContent insight={insight} />
        </Box>
      ))}
    </>
  );
}
